import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Typography, Button, styled } from '@mui/material';

const CTASection = () => {
    return (
        <SectionWrapper id="contact">
            <SectionGlow />
            <Container maxWidth="lg">
                <Typography
                    component="span"
                    sx={{
                        display: 'inline-block',
                        fontSize: { xs: '0.6875rem', sm: '0.75rem' },
                        fontWeight: 700,
                        letterSpacing: '0.18em',
                        textTransform: 'uppercase',
                        color: 'white',
                        bgcolor: 'rgba(17, 0, 255, 0.1)',
                        px: { xs: 1.75, sm: 2.25 },
                        py: 0.75,
                        borderRadius: 999,
                        mb: 2.5,
                    }}
                >
                    Get started
                </Typography>
                <ContentBox>
                    <CTATitle>
                        Your next cycle doesn't have
                        <br />
                        to start with a dispute.
                    </CTATitle>
                    <CTASubtitle>
                        See exactly how it works for a centre your size - session verification, documentation, payout
                        calculation. One walkthrough, 20 minutes.
                    </CTASubtitle>
                    <ButtonGroup>
                        <CtaButton
                            variant="outlined"
                            component={RouterLink}
                            to="/demo"
                            id="Book-demo-button"
                            data-gtm="Book-demo-button"
                        >
                            Book a demo
                        </CtaButton>
                        <CtaButton
                            variant="outlined"
                            component="a"
                            href="https://wa.me/919187644794"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Talk to us on WhatsApp
                        </CtaButton>
                    </ButtonGroup>
                </ContentBox>
            </Container>
        </SectionWrapper>
    );
};

const SectionWrapper = styled(Box)({
    position: 'relative',
    padding: '80px 0',
    background: 'linear-gradient(135deg, #0066FF 0%, #6366F1 50%, #4F46E5 100%)',
    color: '#fff',
    textAlign: 'center',
    overflow: 'hidden',
    '@media (max-width: 768px)': {
        padding: '60px 0',
    },
    '@media (max-width: 480px)': {
        padding: '50px 0',
    },
});

const SectionGlow = styled(Box)({
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: 'none',
    '&::before': {
        content: '""',
        position: 'absolute',
        top: '-30%',
        right: '-10%',
        width: '500px',
        height: '500px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 255, 255, 0.12) 0%, transparent 70%)',
    },
    '&::after': {
        content: '""',
        position: 'absolute',
        bottom: '-40%',
        left: '-10%',
        width: '600px',
        height: '600px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 255, 255, 0.08) 0%, transparent 70%)',
    },
});

const ContentBox = styled(Box)({
    position: 'relative',
    zIndex: 1,
    maxWidth: '800px',
    margin: '0 auto',
});

const CTATitle = styled(Typography)({
    fontSize: '56px',
    fontWeight: 800,
    lineHeight: 1.1,
    letterSpacing: '-1.5px',
    marginBottom: '24px',
    '@media (max-width: 768px)': {
        fontSize: '32px',
        marginBottom: '16px',
    },
    '@media (max-width: 480px)': {
        fontSize: '26px',
    },
});

const CTASubtitle = styled(Typography)({
    fontSize: '22px',
    lineHeight: 1.6,
    marginBottom: '40px',
    opacity: 0.95,
    '@media (max-width: 768px)': {
        fontSize: '16px',
        marginBottom: '32px',
    },
    '@media (max-width: 480px)': {
        fontSize: '15px',
        marginBottom: '28px',
    },
});

const ButtonGroup = styled(Box)({
    display: 'flex',
    gap: '16px',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '@media (max-width: 480px)': {
        flexDirection: 'column',
        gap: '12px',
    },
});

const CtaButton = styled(Button)({
    background: 'transparent',
    color: '#fff',
    border: '2px solid rgba(255, 255, 255, 0.37)',
    fontWeight: 600,
    padding: '14px 32px',
    fontSize: '16px',
    '&:hover': {
        background: 'rgba(55, 38, 154, 0.27)',
        borderColor: '#fff',
        color: '#fff',
    },
    '@media (max-width: 480px)': {
        width: '100%',
    },
});

export default CTASection;
